import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Typography } from "@mui/material";

const Godview = ({ message, onClose }) => {
  return (
    <Box
      style={{
        transform: "translateX(-50%)",
        position: "fixed",
        zIndex: 999999,
        backgroundColor: "#fafafa",
        border: "2px solid #FFCC00",
        padding: "16px",
        paddingRight: "22px",
        borderRadius: "4px",
        left: "50%",
        top: "8px",
      }}
    >
      <Typography variant="body1">{message}</Typography>
      {onClose && (
        <IconButton
          aria-label="Close godview message"
          onClick={onClose}
          size="small"
          style={{ position: "absolute", top: "0", right: "0" }}
          disableFocusRipple
          disableRipple
        >
          <CloseIcon style={{ fontSize: "14px" }} />
        </IconButton>
      )}
    </Box>
  );
};

export default Godview;
